export default (scrollContainer, querySelector, extraOffset = 0) => {
    if (!querySelector) {
        return;
    }

    const container = document.querySelector(scrollContainer);
    const element = querySelector instanceof Element ? querySelector : container.querySelector(querySelector);
    if (!element) {
        return;
    }
    const boundingClientRect = element.getBoundingClientRect();
    let offsetTop = boundingClientRect.top;
    offsetTop -= 20;
    offsetTop -= extraOffset

    container.scrollTo({behavior: 'smooth', top: offsetTop});
}
